
import React from "react";
import "./SuccessiveVCs.css";
import Navbar from "../../components/Homepage/Navbar/Navbar";
import Footer from "../../components/Homepage/Footer/Footer";
import {
  vcsList,
  inchargeVCsList,
} from "../../data/vcData.js";

const SuccessiveVCs = () => {
  const reversedVCs = [...vcsList].reverse();
  const reversedInchargeVCs = [...inchargeVCsList].reverse();

  const renderVCCards = (list) =>
    list.map((vc) => (
      <div key={vc.id} className="vc-card">
        <div className="vc-period">{vc.period}</div>

        <div className="vc-content">
          <div className="vc-image">
            <img src={vc.image} alt={vc.name} />
          </div>

          <div className="vc-details">
            <h2>{vc.name}</h2>
          </div>
        </div>
      </div>
    ));

  return (
    <div className="successive-vcs-page">
      <Navbar />

      <div className="successive-vcs-container">
        {/* Successive Vice Chancellors */}
        <div className="page-header">
          <h1>Successive Vice Chancellors</h1>
          <div className="header-underline"></div>
        </div>

        <div className="vcs-timeline">
          {renderVCCards(reversedVCs)}
        </div>

        {/* In-charge Vice Chancellors */}
        <div className="page-header incharge-vcs-header">
          <h1>In-charge Vice Chancellors</h1>
          <div className="header-underline"></div>
        </div>

        <div className="vcs-timeline">
          {renderVCCards(reversedInchargeVCs)}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SuccessiveVCs;
